import { Flex, Text, useRadio } from '@chakra-ui/react';

const RadioItem = ({ text, helper, ...props }) => {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Flex dir="row" alignItems="center" as="label" w="100%" cursor={props.isDisabled ? 'inherit' : 'pointer'}>
      <input {...input} />
      <Text
        as="span"
        borderWidth="2px"
        width="4"
        height="4"
        display="inline-flex"
        borderRadius="50%"
        justifyContent="center"
        alignItems="center"
        _checked={{
          bg: 'blue.500',
          borderColor: 'blue.500',
          _before: {
            background: 'white',
            content: '" "',
            width: '50%',
            height: '50%',
            position: 'relative',
            display: 'inline-block',
            borderRadius: '50%',
          },
          _hover: {
            background: 'blue.600',
            borderColor: 'blue.600',
          },
        }}
        {...checkbox}
      />
      <Flex direction="column" alignItems="start" ml="4">
        <Text color="gray.700">{text}</Text>
        <Text as="span" fontSize="sm" color="gray.400">{helper}</Text>
      </Flex>
    </Flex>
  );
};
export default RadioItem;
